<style scoped lang="scss">
    .message {
        cursor: pointer;
        padding: 20px 20px 20px 0;
        background-color: #f8f8f8;
        align-items: center;
        &:hover {
            background-color: #eeeeee;
        }
        &:nth-child(even) {
            background-color: white;
            &:hover {
                background-color: #eeeeee;
            }
        }

        .message-subject {
            font-size: 1.2em;
            margin-bottom: 2px;
        }

        .message-meta {
            font-size: 1.1em;
            color: #888;
        }

        .message-body {
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            color: #444;
        }

        &.new {
            .message-subject {
                font-weight: bold;
            }
        }
    }


</style>

<template>
    <div :class="{'message': true, 'uk-grid': true, new: !isSeen}" style="margin: 0;" @click="$router.push('/messages/'+message.id)">
        <div class="uk-flex uk-flex-column uk-width-large-7-10 uk-width-small-1-1">
            <div class="message-subject">{{ message.subject }}</div>
            <span class="message-meta" style="margin-bottom: 10px;">
                From: {{ message.owner.name | obscuredName }}
                |
                {{ message.created_at | moment('MM/DD/YYYY h:m a') }}
                <span v-if="message.replies">
                    | {{ message.replies.length + 1 }} messages
                </span>

            </span>
            <div class="message-body">
                {{ message.message }}
            </div>
        </div>

        <div class="uk-width-large-3-10">
            <div class="uk-float-right">
                <!-- <button class="uk-button" uk-tooltip="test" v-if="!isSeen" @click.stop="markAsRead">
                    <i class="uk-icon-check-circle"></i>
                    Mark as Read
                </button> -->
                <button class="uk-button" uk-tooltip="test" @click.stop="$router.push('/messages/'+message.id)">
                    <i class="uk-icon-reply"></i>
                    Reply
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "MessageListItem",
        props: {
            message: {
                default: {},
            },
            user: {
                default: {},
            },
            expanded: {
                type: Boolean,
                default: false,
            }
        },

        data() {
            return {
                isExpanded: false,
            }
        },
        watch: {
            expanded(newValue) {
                this.isExpanded = newValue;
            }
        },
        mounted() {
            this.isExpanded = this.expanded;
        },
        computed: {
            isSeen() {
                let isSeen = false;
                for(var i in this.message.recipients) {
                    let recipient = this.message.recipients[i];
                    if(recipient.seen_at !== null && recipient.user_id == this.user.id) {
                        isSeen = true;
                    }
                }

                return isSeen;
            }
        },
        methods: {
            markAsRead($event) {
                axios.post('/api/hope/communications/'+this.message.id+'/mark-read').then(r => {
                    this.$emit('updated', {message: r.data.communication});
                })
            },
            reply($event) {

            }
        }

    }
</script>
